export function CheckOutConfirmationModal({ isOpen, onClose, onConfirm, jobTitle, checkInDate, isLoading }) {
    if (!isOpen) return null;

    const formattedCheckInTime = checkInDate.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: true });
    const diffMs = new Date() - checkInDate;
    const diffSecs = Math.max(0, Math.floor(diffMs / 1000));
    const h = Math.floor(diffSecs / 3600);
    const m = Math.floor((diffSecs % 3600) / 60);
    const s = diffSecs % 60;
    const durationStr = `${String(h).padStart(2, '0')}h ${String(m).padStart(2, '0')}m ${String(s).padStart(2, '0')}s`;

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
            <div className="absolute inset-0 bg-slate-900/60 backdrop-blur-sm transition-opacity" onClick={() => !isLoading && onClose()} />
            <div className="relative z-10 w-full max-w-sm transform overflow-hidden rounded-2xl bg-white border border-slate-200 p-6 text-left shadow-2xl transition-all animate-in fade-in zoom-in-95 duration-200">
                <div className="flex items-center justify-between pb-3 border-b border-slate-200 mb-4">
                    <h3 className="text-base font-semibold text-slate-800">Check Out</h3>
                    <button onClick={onClose} disabled={isLoading} className="text-slate-400 hover:text-slate-600 transition-colors cursor-pointer disabled:opacity-50 disabled:cursor-not-allowed">
                        <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                        </svg>
                    </button>
                </div>

                <p className="text-xs text-slate-600 mb-4 font-medium">
                    Are you sure you want to check out from this job?
                </p>

                <div className="bg-slate-50 border border-slate-200 p-3.5 rounded-xl space-y-2.5 mb-5">
                    <div>
                        <p className="text-[10px] font-semibold text-slate-500 tracking-wide mb-0.5">Job</p>
                        <p className="text-xs font-semibold text-slate-800">{jobTitle}</p>
                    </div>
                    <div className="grid grid-cols-2 gap-4">
                        <div>
                            <p className="text-[10px] font-semibold text-slate-500 tracking-wide mb-0.5">Checked in</p>
                            <p className="text-xs font-semibold text-slate-700">{formattedCheckInTime}</p>
                        </div>
                        <div>
                            <p className="text-[10px] font-semibold text-slate-500 tracking-wide mb-0.5">Current duration</p>
                            <p className="text-xs font-semibold text-slate-700">{durationStr}</p>
                        </div>
                    </div>
                </div>

                <div className="flex gap-3">
                    <button
                        onClick={onClose}
                        disabled={isLoading}
                        className="flex-1 py-2.5 rounded-xl border border-slate-200 bg-white hover:bg-slate-50 text-slate-700 font-semibold text-xs transition-all flex items-center justify-center cursor-pointer disabled:opacity-50 disabled:cursor-not-allowed"
                    >
                        Cancel
                    </button>
                    <button
                        onClick={onConfirm}
                        disabled={isLoading}
                        className="flex-1 py-2.5 rounded-xl bg-rose-600 hover:bg-rose-500 text-white font-semibold text-xs transition-all shadow-md flex items-center justify-center cursor-pointer disabled:opacity-50 disabled:cursor-not-allowed gap-1.5"
                    >
                        {isLoading ? (
                            <>
                                <div className="h-3 w-3 animate-spin rounded-full border border-white/30 border-t-white" />
                                <span>Checking Out...</span>
                            </>
                        ) : (
                            <span>Confirm Check Out</span>
                        )}
                    </button>
                </div>
            </div>
        </div>
    );
}
